import {
    initContentTooltips,
    CollabsibleContainer,
    lockBody,
    unlockBody,
    FilterPopup,
} from "@plugins";
import { elementScrollIntoView } from "seamless-scroll-polyfill";
import jquery from "jquery";

const $ = jquery;
const filter = document.querySelector(".js-filter");
const filterCheckboxesContainers = document.querySelectorAll(".js-filter-checkboxes");
const filterCategoriesContainer = document.querySelector(".js-filter-categories-scrolling-init");
const tooltipOptions = {
    placement: "top",
    interactive: false,
};

$(document).ajaxSuccess(() => {
    initContentTooltips(".js-filter-block-tooltip-init", tooltipOptions);
    toggleFilterModal();
});

if (filterCheckboxesContainers) {
    filterCheckboxesContainers.forEach((filterCheckboxesContainer) => {
        new CollabsibleContainer(filterCheckboxesContainer, {
            buttonClasses: "link-more filter__checkboxes-more js-filter-checkboxes-more collapsed",
            collapsibleItemsClass: "js-filter-checkboxes-item",
            limiter: 8,
        });
    });
}

function initFilterModal() {
    if (filter) {
        new FilterPopup(filter);
    }
}

function toggleFilterModal() {
    if (filter && window.mobileMedia) {
        const filterOpenBtn = filter.querySelector(".js-filter-modal-open");
        const filterCloseBtn = filter.querySelector(".js-filter-modal-close");
        const filterForm = filter.querySelector(".js-filter-form");

        filterOpenBtn.addEventListener("click", () => {
            filterForm.classList.add("opened");
            lockBody(filterForm);
        });
        filterCloseBtn.addEventListener("click", () => {
            filterForm.classList.remove("opened");
            unlockBody();
        });
    }
}

function initScrollingFilterElements() {
    if (filterCategoriesContainer) {
        const filterCategoriesItems = filterCategoriesContainer.querySelectorAll(
            ".filter__categories-item",
        );

        if (filterCategoriesItems.length > 0) {
            filterCategoriesItems.forEach((item) => {
                item.addEventListener("click", () => {
                    const filterBlocks = document.querySelectorAll(".filter__form-block");

                    if (filterBlocks.length > 0) {
                        filterBlocks.forEach((block) => {
                            if (block.dataset.id === item.id) {
                                elementScrollIntoView(block, {
                                    behavior: "smooth",
                                    block: "start",
                                });
                            }
                        });
                    }
                });
            });
        }
    }
}

window.addEventListener(
    "load",
    initContentTooltips(".js-filter-block-tooltip-init", tooltipOptions),
    toggleFilterModal(),
    initFilterModal(),
    initScrollingFilterElements(),
);
